import { render, staticRenderFns } from "./painting-task.vue?vue&type=template&id=2e0281ea&scoped=true"
import script from "./painting-task.vue?vue&type=script&lang=js"
export * from "./painting-task.vue?vue&type=script&lang=js"
import style0 from "./painting-task.vue?vue&type=style&index=0&id=2e0281ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0281ea",
  null
  
)

export default component.exports